<script>
     import { _ } from "svelte-i18n";
</script>

<div class="bg-gradient-to-r from-gradient1 to-gradient2 text-center">
    <a target="_blank" href="https://biliplus.de/impressum">  
        {$_('footer.impressum')} 
    </a>
</div>
